import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface BrandingConfig {
  logo_url: string | null;
  primary_color: string;
  secondary_color: string;
  font_family: string;
  login_message: string | null;
  dashboard_footer: string | null;
  powered_by_text: string | null;
}

interface BrandingPreviewProps {
  branding: BrandingConfig;
}

export function BrandingPreview({ branding }: BrandingPreviewProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Live Preview</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Mini Login Preview */}
        <div 
          className="border rounded-lg p-4 bg-background"
          style={{ fontFamily: branding.font_family }}
        >
          <div className="text-center mb-4">
            {branding.logo_url ? (
              <img 
                src={branding.logo_url} 
                alt="Logo" 
                className="h-8 mx-auto object-contain"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = "none";
                }}
              />
            ) : (
              <div 
                className="h-8 w-24 mx-auto rounded flex items-center justify-center text-xs font-bold text-white"
                style={{ backgroundColor: branding.primary_color }}
              >
                LOGO
              </div>
            )}
          </div>
          {branding.login_message && (
            <p className="text-xs text-muted-foreground text-center mb-3">
              {branding.login_message}
            </p>
          )}
          <div className="space-y-2">
            <Input 
              placeholder="Email" 
              className="h-8 text-xs" 
              disabled 
            />
            <Input 
              placeholder="Password" 
              type="password" 
              className="h-8 text-xs" 
              disabled 
            />
            <Button 
              className="w-full h-8 text-xs"
              style={{ 
                backgroundColor: branding.primary_color,
                color: "white",
              }}
              disabled
            >
              Sign In
            </Button>
          </div>
        </div>

        {/* Color Swatches */}
        <div className="space-y-2">
          <p className="text-sm font-medium">Colors</p>
          <div className="flex gap-2">
            <div className="flex-1">
              <div 
                className="h-8 rounded-md"
                style={{ backgroundColor: branding.primary_color }}
              />
              <p className="text-xs text-muted-foreground mt-1 text-center">Primary</p>
            </div>
            <div className="flex-1">
              <div 
                className="h-8 rounded-md"
                style={{ backgroundColor: branding.secondary_color }}
              />
              <p className="text-xs text-muted-foreground mt-1 text-center">Secondary</p>
            </div>
          </div>
        </div>

        {/* Typography */}
        <div className="space-y-2">
          <p className="text-sm font-medium">Typography</p>
          <div 
            className="p-3 border rounded-md"
            style={{ fontFamily: branding.font_family }}
          >
            <p className="text-lg font-bold">Heading Text</p>
            <p className="text-sm text-muted-foreground">
              Body text in {branding.font_family}
            </p>
          </div>
        </div>

        {/* Footer Preview */}
        {(branding.dashboard_footer || branding.powered_by_text) && (
          <div className="space-y-2">
            <p className="text-sm font-medium">Footer</p>
            <div 
              className="p-3 border rounded-md text-center text-xs text-muted-foreground"
              style={{ fontFamily: branding.font_family }}
            >
              {branding.dashboard_footer && (
                <p>{branding.dashboard_footer}</p>
              )}
              {branding.powered_by_text && (
                <p className="mt-1 opacity-70">{branding.powered_by_text}</p>
              )}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
